export const shouldHideUpsells = () => true;
